import i18n from "i18next";
import { z } from "zod";
import { getAtcAfterAtsError, notificationSchema } from "../utils";
import { createAtcSchema } from "./sharedClosePortServiceSchemas";

const LANG_BASE = "vessel-call.port-services.fields";

const shipToShipFieldsSchema = () =>
  z.object({
    cargoType: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;
        return value;
      },
      z.string({
        required_error: i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.cargo-type`),
        }),
      }),
    ),
    operationType: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;
        return value;
      },
      z.string({
        required_error: i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.operation-type`),
        }),
      }),
    ),
    actualQuantity: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;

        const parsed = Number(value);
        return Number.isNaN(parsed) ? value : parsed;
      },
      z.number({
        required_error: i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.quantity-tons`),
        }),
        invalid_type_error: i18n.t("form-validation.invalid-number", {
          label: i18n.t(`${LANG_BASE}.quantity-tons`),
        }),
      }),
    ),
  });

const billOfLadingAttachmentSchema = z.object({
  billOfLading: z
    .object({
      documentUrl: z.string().optional(),
      documentName: z.string().optional(),
      fileType: z.string().optional(),
    })
    .superRefine((val, ctx) => {
      const hasDocument = !!val?.documentUrl?.trim();

      if (!hasDocument) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [],
          message: i18n.t("form-validation.mandatory", {
            label: i18n.t(`${LANG_BASE}.bill-of-lading`),
          }),
        });
      }
    }),
});

export const closeShipToShipSchema = (ats?: string | Date | null) =>
  createAtcSchema()
    .merge(shipToShipFieldsSchema())
    .merge(billOfLadingAttachmentSchema)
    .merge(notificationSchema)
    .superRefine((value, ctx) => {
      const error = getAtcAfterAtsError(value.atc, ats);

      if (!error) {
        return;
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["atc"],
        message: error,
      });
    });

export type CloseShipToShipSchema = z.infer<ReturnType<typeof closeShipToShipSchema>>;
